import styled from 'styled-components';

import { SelectColor } from '../../../../services/reports';

export const StyledGoogleAdsMetrics = styled.div`
  padding: 15px 0 0;
  
  h2 {
  	font-family: Poppins-Medium, Heltica, Arial, sans-serif;
    font-size: 15px;
    color: #2B2932;
    margin: 0 0 10px 0;
  }

  ul {
    margin: 0;
    padding: 0;
    list-style: none;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    
    @media screen and (max-width: 910px) {
      flex-direction: column;
      justify-content: center;
    }
    
    li {
      flex: 1;
      background-color: #FFFFFF;
      border: 1px solid #F1F1F5;
      box-shadow: 0 6px 4px rgba(0, 0, 0, .2);
      border-radius: 5px;
      padding: 20px;
      min-width: 250px;
      margin: 10px 20px 10px 0;
      
      &:last-child {
      	margin: 10px 0 10px 0;
      }
      
      @media screen and (max-width: 910px) {
        flex-direction: column;
        justify-content: center;
        min-width: auto;
        width: 100%;
        max-width: 250px;
        margin: 10px auto;
      }
    
      .top {
        display: flex;
        align-items: center;
        margin-bottom: 25px;
        
        h5 {
          margin: 0;
          font-family: Poppins-Medium, Heltica, Arial, sans-serif;
          font-size: 15px;
          color: #2B2932;
        }
      }
      
      .content {
        display: flex;
        justify-content: center;
      
        p {
          margin: 0;
          display: inline-block;
          font-family: Poppins, Heltica, Arial, sans-serif;
          font-size: 25px;
          line-height: 1.5em;
          color: #2B2932;
          display: flex;
          flex-direction: column;
          align-items: center;
          max-width: 75px;
          
          &:after {
            content: '';
            display: block;
            width: 130%;
            height: 2px;
            background-color: ${props => SelectColor(props.channel)};
            border-radius: 3px;
          }
        }
      }
    }
  }

  section {
    padding: 10px 40px 0;
    
    .description {
      font-family: Poppins, Heltica, Arial, sans-serif;
      font-size: 14px;
      line-height: 1.5em;
      color: #2B2932;
      margin-bottom: 30px;
    }
  }
`;
